<template>
	<div></div>
</template>

<script>
	import {getPoiDetail} from '@/fetch/api'
	export default {
		data() {
			return {
				currentEnv: null,
				header: null,
				routeArray: ['', '', '', '', '', '', '', '', '']
			}
		},
		created() {
			this.currentEnv = window.__wxjs_environment === 'miniprogram' || /miniProgram/i.test(navigator.userAgent.toLowerCase())
			this.header = this.$route.query.token ? { 'X-CLIENT-ID': query.clientId, 'X-ACCESS-TOKEN': query.token, 'X-USER-ID': query.userId } : null
			this.toast = this.$createToast({
			    time: 0,
			    txt: this.$t('common.loadingMsg'),
			    mask: true
			})
			if(localStorage.getItem('poiGroups')) {
				this.setNavigationInfo()
			} else {
				this.getNacigationDetail()
			}
		},
		methods: {
			setNavigationInfo() {
				let poiGroups = JSON.parse(localStorage.getItem('poiGroups'))
				const {type, id} = this.$route.query
				poiGroups.forEach(item => {
					if(item.poi_type.toLowerCase() === type.toLowerCase()) {
						item.pois.forEach(poi => {
							if(poi.id = id) {
								this.routeArray = ['', '', '', '', '', poi.lon, poi.lat, poi.name, type, id]
							}
						})
					}
				})
				this.jmpRouter()
			},
			getNacigationDetail() {
				const {type, id} = this.$route.query
				
				this.toast.show()
				getPoiDetail({type, id}).then(res => {
					this.routeArray = ['', '', '', '', '', res.lon, res.lat, res.name, type, id]
					this.jmpRouter()
				})
			},
			jmpRouter() {
				let routeArray = this.routeArray
				if (this.currentEnv) { // 小程序环境下跳转小程序页面
				    window.wx.miniProgram.navigateTo({
				        url: `/packageTourGuide/map/navigationMapPage/index?data=${encodeURIComponent(JSON.stringify(routeArray))}`
				    })
				} else {
				    // ios13. safari需要请求获取朝向的权限
				    this.askForPermission()
				    if (this.header) {
				        this.header['X-CLIENT-ID'] && routeArray.push(this.header['X-CLIENT-ID'])
				        this.header['X-ACCESS-TOKEN'] && routeArray.push(this.header['X-ACCESS-TOKEN'])
				        this.header['X-USER-ID'] && routeArray.push(this.header['X-USER-ID'])
				    }
				    let url =  '/navigateweb'
				    let params = { siteId: 1, data: encodeURIComponent(JSON.stringify(routeArray)) }
				    if (this.$route.query.language === 'zh') Object.assign(params, { language: 'zh' })
				    this.$store.commit('SET_DIRECT', false)
					this.toast.hide()
				    this.$router.replace({
				        path: url, query: params
				    })
				}
			},
			askForPermission () {
			    console.log('询问是否允许使用方向')
			    // ios 13
			    if (typeof DeviceOrientationEvent.requestPermission === 'function') {
			        DeviceOrientationEvent.requestPermission().then(permissionState => {
			            if (permissionState === 'granted') {
			                // window.addEventListener('deviceorientation', this.handleOrientation)
			            }
			        }).catch(err => {
			            this.toast = this.$createToast({
			                time: 1500,
			                type: 'txt',
			                txt: this.$t('common.orientationMsg')
			            })
			            this.toast.show()
			        })
			    }
			}
		}
	}
</script>

<style>
</style>
